import React, { useState } from "react";
import {
	IonMenu,
	IonHeader,
	IonToolbar,
	IonContent,
	IonLoading,
	IonFooter,
	IonButton,
	IonItemGroup,
	IonImg,
	IonItemDivider,
	IonLabel,
} from "@ionic/react";
import { menuController } from "@ionic/core";
import { connect } from "react-redux";

import { logout } from "../../services/auth";
import FrontendMenu from "./FrontendMenu";
import { useHistory } from "react-router-dom";
import MenuUserList from "../../pages/Users/components/MenuUserList";

interface Props {
	user: any;
}

const AppMenu: React.FC<Props> = ({ user }) => {
	const history = useHistory();
	const [busy, setBusy] = useState<boolean>(false);

	const closeMenu = async () => {
		await menuController.toggle();
	};

	async function _logOut() {
		//console.log("logging out");
		closeMenu();
		setBusy(true);
		logout();
		setBusy(false);
	}

	return (
		<IonMenu side="start" contentId="main-content">
			<IonHeader>
				<IonToolbar color="primary">
					<IonImg
						className="header-image linked"
						onClick={() => history.push("/dashboard")}
						src={
							"https://firebasestorage.googleapis.com/v0/b/waiora-tamariki.appspot.com/o/assets%2Fwaiora-tamariki-logo_app-header-white.png?alt=media&token=f05bfb5c-29ea-47f1-8082-9e33898d6eac"
						}
					></IonImg>
				</IonToolbar>
			</IonHeader>
			<IonLoading message="Logging out..." duration={0} isOpen={busy} />
			<IonContent>
				<IonItemGroup>
					<FrontendMenu />
					{/* {user.isAdmin && (
						<IonItemDivider>
							<IonLabel>Users</IonLabel>
						</IonItemDivider>
					)}

					<MenuUserList /> */}
				</IonItemGroup>
			</IonContent>
			<IonFooter className="ion-padding">
				<IonToolbar>
					<IonButton onClick={_logOut}>Logout</IonButton>
				</IonToolbar>
			</IonFooter>
		</IonMenu>
	);
};

const mapStateToProps = (state: any) => ({
	user: state.user.userDetails,
	// slides: state.slides,
});

export default connect(mapStateToProps, {})(AppMenu);
